/**
 * Indigo wordmark served from indigo.ca's Shopify CDN, so it tracks the
 * storefront's current logo. Width/height attributes reserve space before the
 * SVG loads; the default class matches the storefront header sizing.
 */
const INDIGO_LOGO_SRC = '//www.indigo.ca/cdn/shop/files/global_header_logo.svg?v=1746733738';

export default function IndigoLogo({
  className = 'h-7 min-[900px]:h-[42px] w-auto',
}: Readonly<{ className?: string }>) {
  return <img src={INDIGO_LOGO_SRC} alt="Indigo" width="90" height="47" className={className} />;
}
